<template>
    <div class="verify-code">
        <div class="code-box" v-for="item in num" :key="item">
            <div ref="ref"></div>
            <div class="code-in" v-show="lineNum === item"></div>
        </div>
        <input class="input" type="text" :aria-label="value" :value="value" @input="changePwd" @keyup.delete="deletePwd" ref="input" :disabled="isable">
    </div>
</template>
<script>
    // import { request } from 'lib/js/tool'

export default {
  props: {
    num: {
      type: Number,
      default: 4
    },
    url: {
      type: String
    },
    type: {
      type: String,
      default: 'number'
    }
  },
  data () {
    return {
      currentNum: 1,
      lineNum: 1,
      value: '',
      allowDel: true,
      isable: false,
      tempisable: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
      this.setType()
    })
  },
  methods: {
    init () {
      // this.$refs.input.focus()
    },
    setType () {
      this.$refs.input.setAttribute('type', this.type)
    },
    changeHanlder (type, value) {
      console.log(type + ':' + value)
    },
    changePwd (e) {
      this.value = event.target.value
      let text = this.value
      // let regExp = /^[0-9]{1}$/
      // 这样一次只匹配一位数字若用户粘贴则不生效
      let regExp = /^[0-9]+?$/
      if (this.type === 'password') {
        regExp = /^[a-zA-Z]{1}$/
      }
      if (this.value !== '' && regExp.test(text)) {
        const textArr = text.toString().split('')
        if (textArr.length > this.num) {
          textArr.length = this.num
        }
        const self = this
        textArr.forEach(item => {
          self.$refs.ref[self.currentNum - 1].innerHTML = item
          self.currentNum++
          self.lineNum++
        })
      }
      e.target.value = ''
      this.value = ''
      if (this.currentNum > this.num) {
        this.isable = true
        this.currentNum = this.num
        this.lineNum = this.num + 1
        this.allowDel = false
        let code = ''
        for (let i = 0; i < this.num; i++) {
          code += this.$refs.ref[i].innerHTML
        }
        this.$emit('fillCb', code)
      }
    },
    deletePwd () {
      if (this.allowDel) {
        this.currentNum = this.currentNum <= 1 ? 1 : this.currentNum - 1
        this.lineNum = this.currentNum
        this.$refs.ref[this.currentNum - 1].innerHTML = ''
      }
    },
    clear () {
      this.currentNum = 1
      this.lineNum = 1
      this.allowDel = true
      this.isable = false
      for (let i = 0; i < this.num; i++) {
        this.$refs.ref[i].innerHTML = ''
      }
    }
  }
}
</script>
<style lang="scss">
@import '~common-css/mixins.scss';
  .verify-code {
    position: relative;
    display: flex;
    width: px2rem(558);
    overflow: hidden;
    border: 1px solid rgba(0,0,0,0.50);
    margin: 0 auto;
    .code-box {
      flex: 1;
      position: relative;
      height: px2rem(92);
      line-height: px2rem(92);
      text-align: center;
      vertical-align: top;
      @include border-left-1px(rgba(0,0,0,0.10));
      &:first-child {
          border-left: 0;
      }
      .code-in {
        position: absolute;
        top: px2rem(22);
        left: 50%;
        width: px2rem(3);
        height: px2rem(48);
        background-color: #fc9153;
        animation: flicker 1s infinite;
      }
      @keyframes flicker {
        0% {
          opacity: 1;
        }
        20% {
          opacity: 0;
        }
        60% {
          opacity: 0;
        }
        80% {
          opacity: 1;
        }
      }
    }
    .input {
      position: absolute;
      top: 0;
      left: 0;
      width: 200%;
      height: px2rem(92);
      border: 1px solid #000;
      margin-left: px2rem(-558);
      opacity: 0;
    }
  }
</style>
